import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';


const defaultDocUploadSubtitle = `SheerID is reviewing your documents, to confirm your
                        status. This process may take up to 20 minutes.`;

const defaultDocUploadSubtitle2 = 'Wait here or let us notify you of the outcome.';

const defaultDocUploadSubtitle3 = 'You will be contacted via email.';

const ReviewPending = ({ intl, logo, maxReviewTime }) => (
    <div className="sid-header sid-l-horz-center" data-testid="sid-review-pending">
        <div className="sid-l-horz-center">
            { logo }
        </div>
        <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
            <FormattedHTMLMessage id="step.pending.titleReview" defaultMessage="Reviewing" />
        </div>
        <div className="sid-header__subtitle-one">
            <FormattedHTMLMessage
                id="step.pending.subtitle"
                defaultMessage={defaultDocUploadSubtitle}
                values={{
                    maxReviewTime: intl.formatMessage({
                        id: `dateTime.${maxReviewTime}`,
                        default: '2 hours',
                    }),
                }}
            />
        </div>
        <div className="sid-header__subtitle-two sid-l-space-top-md">
            <FormattedHTMLMessage
                id="step.pending.subtitle2"
                defaultMessage={defaultDocUploadSubtitle2}
            />
        </div>
        <div className="sid-header__subtitle-three sid-l-space-top-md">
            <FormattedHTMLMessage
                id="step.pending.subtitle3"
                defaultMessage={defaultDocUploadSubtitle3}
            />
        </div>
        <div className="sid-l-space-top-xl" />
    </div>
);

export const ReviewPendingComponent = ReviewPending;
